import { useMutation, useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/api/query-keys'
import { completeTeamInvitation, validateTeamInvitationToken } from './teamInvitation.api'

export function useValidateTeamInvitationToken(token: string | undefined) {
  const t = token?.trim() ?? ''
  return useQuery({
    queryKey: queryKeys.team.invitationValidate(t),
    queryFn: () => validateTeamInvitationToken(t),
    enabled: t.length > 0,
    retry: false,
    staleTime: 0,
  })
}

export function useCompleteTeamInvitation() {
  return useMutation({
    mutationFn: completeTeamInvitation,
  })
}
